import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RightRail, LeftRail, GiftRailCTA, GiftHeader, MobileGiftRailCTA } from '../../components';
import { GiftCardsWrapper } from '../../containers';
import en from '../../international/translations/en';

class GiftPurchase extends Component {
  renderHeader = (purchaseSuccess, data) => {
    const copy = purchaseSuccess ? {
      headerText: en.giftCards.success.headerText,
      subHeaderText: en.giftCards.success.subHeaderText(data.purchaserEmail)
    } :
      { ...en.giftCards.select };
    return <GiftHeader copy={copy} />;
  };

  render() {
    const {
      purchaseSuccess,
      savedGiftData
    } = this.props;
    const ctaCopy = en.giftCards;
    return (
      <div>
        <div className="gift-purchase">
          <MobileGiftRailCTA ctaCopy={ctaCopy} />
          <LeftRail>
            <div className="gift-purchase__content">
              {this.renderHeader(purchaseSuccess, savedGiftData)}
              <GiftCardsWrapper />
            </div>
          </LeftRail>
          <RightRail>
            <GiftRailCTA ctaCopy={ctaCopy} />
          </RightRail>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  purchaseSuccess: state.gifts.purchaseSuccess,
  savedGiftData: state.gifts.savedGiftData
}))(GiftPurchase);
